// Shared helpers for the IT Budget pages: access checks, chips, formatting.

export { fmtDate, fmtTime, pillStyle } from "../Proposals/ProductLibrary/productLibraryUtils";

// Access levels are ordered; each includes the ones before it (it_role_permissions.access).
const LEVELS = ["view", "export", "record", "approve", "full"];
export const hasAccess = (access, capability, level) =>
	LEVELS.indexOf(access?.[capability]) >= LEVELS.indexOf(level);

// Chip colours, as the Time Off Console and Product Library use them
export const RED = { fg: "#c62828", bg: "#ffebee" };
export const AMBER = { fg: "#b45309", bg: "#fff3e0" };
export const BLUE = { fg: "#184c93", bg: "#e8f0fe" };
export const GREEN = { fg: "#2e7d32", bg: "#e8f5e9" };
export const GRAY = { fg: "#757575", bg: "#f5f5f5" };

export const STATUS_PILLS = {
	New: BLUE,
	Matched: GREEN,
	Posted: GREEN,
	"Needs Review": RED,
	Excluded: GRAY,
	Duplicate: GRAY,
};
export const MATCH_PILLS = { Matched: GREEN, Provisional: BLUE, "Missing charge": RED, "Amount differs": AMBER };
export const VERSION_PILLS = { active: GREEN, draft: AMBER, retired: GRAY };

// Cents always shown, for reconciling against statements: $1,754.02
export const fmtUSD = (value) => {
	const n = Number(value);
	if (value === null || value === undefined || value === "" || !Number.isFinite(n)) return "—";
	return n.toLocaleString("en-US", { style: "currency", currency: "USD" });
};

// A stored date-only DATETIME ("2026-10-27T00:00:00.000Z") shown without time-zone shifting
export const fmtDay = (value) => {
	if (!value) return "—";
	const s = String(value).slice(0, 10);
	const d = new Date(`${s}T12:00:00`);
	return Number.isNaN(d.getTime()) ? "—" : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDateTime = (value) =>
	value
		? new Date(value).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
		: "—";

// The message from an API error, or a fallback
export const apiError = (error, fallback) => {
	const data = error?.response?.data;
	if (data?.details?.length) return `${data.error}: ${data.details.join("; ")}`;
	return data?.error || error?.message || fallback;
};
